import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'

interface BubbleWrapperProps {
    $isUser: boolean
    isDarkTheme?: boolean
}

export const EmptyChatText = styled.p`
    color: var(--gray);
    text-align: center;
`

export const BubbleWrapper = styled.div<BubbleWrapperProps>`
    display: flex;
    justify-content: ${({ $isUser }) => ($isUser ? 'flex-end' : 'start')};
    & > div {
        margin: 1px;
    }
    a {
        color: ${theme.colors.white};
        text-decoration: underline;
        font-size: 14px;
    }
    p {
        margin: 2px;
        max-width: 325px;
        font-size: 14px;
        font-weight: 400;
        ${({ isDarkTheme }) =>
            isDarkTheme &&
            css`
                max-width: 700px;
                font-size: 16px;
                line-height: 24px;
            `}
    }
`

export const LeftChatBubble = styled.p<{ isDarkTheme?: boolean }>`
    background-color: ${theme.colors.violet};
    border-radius: ${theme.borderRadius.small} ${theme.borderRadius.message} ${theme.borderRadius.message}
        ${theme.borderRadius.message};
    color: ${theme.colors.headlineDark};
    padding: 10px;
    font-family: var(--font-inter);
    font-size: 16px;
    font-style: normal;
    line-height: 22px;
    letter-spacing: 0em;

    ${({ isDarkTheme }) =>
        isDarkTheme &&
        css`
            background-color: ${theme.colors.transparent};
            color: ${theme.colors.white};
        `}
`

export const RightChatBubble = styled.p<{ isDarkTheme?: boolean }>`
    background-color: ${theme.colors.lightGreen};
    border-radius: ${theme.borderRadius.message} ${theme.borderRadius.small} ${theme.borderRadius.message}
        ${theme.borderRadius.message};
    color: ${theme.colors.headlineDark};
    border: 1px solid ${theme.colors.lightGreen};
    padding: 10px;
    font-family: var(--font-inter);
    font-size: 16px;
    font-style: normal;
    line-height: 22px;
    letter-spacing: 0em;

    ${({ isDarkTheme }) =>
        isDarkTheme &&
        css`
            background-color: ${theme.colors.backgroundTransparent};
            border: none;
            color: ${theme.colors.white};
            padding: 10px 12px;
            border-radius: ${theme.borderRadius.webappCard};
        `}
`

export const DateWrapper = styled.div`
    margin: 0;
    .timestamp {
        overflow: hidden;
        color: var(--text-gray);
    }
`

export const EmptyKnowCard = styled.div`
    width: 300px;
    height: 50px;
`
